export default __webpack_public_path__ + "static/media/upload.64b85eb5.svg";